import { render, staticRenderFns } from "./ResumeComponent.vue?vue&type=template&id=4aa57e72&scoped=true"
import script from "./ResumeComponent.vue?vue&type=script&lang=js"
export * from "./ResumeComponent.vue?vue&type=script&lang=js"
import style0 from "./ResumeComponent.vue?vue&type=style&index=0&id=4aa57e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa57e72",
  null
  
)

export default component.exports